import { useEffect } from 'react'
import { batch, useDispatch, useSelector } from 'react-redux'
import AdAccountInfo from './AdAccountInfo'
import CampaignInfo from './CampaignInfo'
import AdGroupInfo from './AdGroupInfo'
import DashboardChart from 'features/dashboard/info/chart/DashboardChart'
import { DashboardInfoTypeNames, DashboardInfoTypes } from 'features/Codes'
import Loading from 'components/loading/Loading'
import TotalCampaignInfo from './TotalCampaignInfo'
import TotalAdGroupInfo from './TotalAdGroupInfo'
import TotalKeywordInfo from './TotalKeywordInfo'
import KeywordInfo from './KeywordInfo'
import TotalCreativeInfo from './TotalCreativeInfo'
import CreativeInfo from './CreativeInfo'
import NoneAnchor from 'components/NoneAnchor'
import {
  clearError,
  fetchDashboardInfoWalletSpend,
  setVisible as setInfoVisible,
} from 'features/dashboard/info/dashboardInfoSlice'
import {
  refreshDashboardTable,
  refreshDashboardTree,
} from 'features/dashboard/dashboardCommonSlice'
import { failWithErrorResponse } from 'features/toast/Toast'
import TotalContentMatchingInfo from './TotalContentMatchingInfo'

const Info = () => {
  const dispatch = useDispatch()
  const { name } = useSelector(state => state.account.current)
  const {
    isLoading,
    visible,
    error,
    type,
    campaign,
    adGroup,
    keyword,
    creative,
  } = useSelector(state => state.dashboard.info)
  const title = DashboardInfoTypeNames[type]

  useEffect(() => {
    if (!error) return
    const { type: errorType } = error
    const errorTitle = DashboardInfoTypeNames[errorType]
    failWithErrorResponse(error, {
      messageMap: {
        409: `삭제된 ${errorTitle} 입니다.`,
      },
    })
    batch(() => {
      dispatch(clearError())
      dispatch(refreshDashboardTree())
      dispatch(refreshDashboardTable())
    })
  }, [error, dispatch])

  useEffect(() => {
    if (visible) {
      dispatch(fetchDashboardInfoWalletSpend())
    }
  }, [dispatch, visible])

  const handleInfoCloseClick = () => {
    dispatch(setInfoVisible(false))
  }

  return (
    visible && (
      <div className="adboardbox_top on">
        <div className="boardbox_tit">
          <strong className="tit_box">
            {type !== DashboardInfoTypes.AD_ACCOUNT && isLoading ? (
              <Loading size={`small`} style={{ textAlign: 'left' }} />
            ) : (
              <>
                {type === DashboardInfoTypes.AD_ACCOUNT && `[${title}]${name}`}
                {type === DashboardInfoTypes.CAMPAIGN &&
                  `[${title}]${campaign?.basic?.name}`}
                {type === DashboardInfoTypes.AD_GROUP &&
                  `[${title}]${adGroup?.basic?.name}`}
                {type === DashboardInfoTypes.KEYWORD &&
                  `[${title}]${keyword?.text}`}
                {type === DashboardInfoTypes.CREATIVE &&
                  `[${title}]${creative?.name}`}
                {[
                  DashboardInfoTypes.TOTAL_CAMPAIGN,
                  DashboardInfoTypes.TOTAL_AD_GROUP,
                  DashboardInfoTypes.TOTAL_KEYWORD,
                  DashboardInfoTypes.TOTAL_CONTENT_MATCHING,
                  DashboardInfoTypes.TOTAL_CREATIVE,
                ].includes(type) && title}
              </>
            )}
          </strong>
        </div>
        <div className="boardbox_card card_graph">
          <div className="detail_info">
            {type === DashboardInfoTypes.AD_ACCOUNT && <AdAccountInfo />}
            {type === DashboardInfoTypes.CAMPAIGN && <CampaignInfo />}
            {type === DashboardInfoTypes.AD_GROUP && <AdGroupInfo />}
            {type === DashboardInfoTypes.KEYWORD && <KeywordInfo />}
            {type === DashboardInfoTypes.CREATIVE && <CreativeInfo />}
            {type === DashboardInfoTypes.TOTAL_CAMPAIGN && (
              <TotalCampaignInfo />
            )}
            {type === DashboardInfoTypes.TOTAL_AD_GROUP && <TotalAdGroupInfo />}
            {type === DashboardInfoTypes.TOTAL_KEYWORD && <TotalKeywordInfo />}
            {type === DashboardInfoTypes.TOTAL_CONTENT_MATCHING && (
              <TotalContentMatchingInfo />
            )}
            {type === DashboardInfoTypes.TOTAL_CREATIVE && (
              <TotalCreativeInfo />
            )}
          </div>
          <div className="detail_graph">
            <DashboardChart />
          </div>
        </div>
        <NoneAnchor className="btn_close" onClick={handleInfoCloseClick}>
          <span className="ico_comm ico_close">닫기</span>
        </NoneAnchor>
      </div>
    )
  )
}

export default Info
